import { SearchAggregationDateInterval } from 'shared/domains/apollo/generated/types';
import { intervalTranslations } from './translations';
const values = Object.values(SearchAggregationDateInterval);
export function allowedIntervals() {
    return values.map((value) => ({
        value,
        label: intervalTranslations(value),
    }));
}
